import { FC } from 'react';
import SafeFlightLogo from './SafeFlightLogo';
import { useScrollAnimation } from './UseScrollAnimation';

interface AirlineCellProps {
    flightNumber: string;
    codeShareFlights: string[];
    logoSize: {
        width: number;
        height: number;
    };
    rowHeight: number;
    globalStartTime: number;
}

const AirlineCell: FC<AirlineCellProps> = ({
    flightNumber,
    codeShareFlights,
    logoSize,
    rowHeight,
    globalStartTime,
}) => {
    const filteredCodeShares = codeShareFlights?.filter(Boolean) || [];

    // Always inline — combine main + codeshares, mirror exact same logic as FlightNumberCell showInline
    const combinedItems = [flightNumber, ...filteredCodeShares];
    const shouldAnimate = filteredCodeShares.length > 0;

    // Double the items for seamless looping — same pattern as FlightNumberCell
    const displayItems = shouldAnimate
        ? [...combinedItems, ...combinedItems]
        : [];

    const { listRef } = useScrollAnimation({
        items: displayItems,
        globalStartTime,
        itemHeight: rowHeight - 2,
        scrollDuration: 1.5,
        animationPrefix: 'airline',  // different prefix to avoid collision with FlightNumberCell
        enabled: shouldAnimate,
    });

    return (
        <div className="scroll-wrapper">
            {shouldAnimate ? (
                <ul className="scroll-item-list" ref={listRef}>
                    {displayItems.map((item, i) => {
                        const originalLength = combinedItems.length;
                        const isMain = (i % originalLength) === 0;
                        return (
                            <li
                                key={i}
                                style={{ height: (rowHeight - 2) + "px" }}
                                className="scroll-item"
                            >
                                <SafeFlightLogo
                                    logoSize={logoSize}
                                    mainFlightNumber={item}  // SafeFlightLogo derives airline code from flight number internally
                                />
                            </li>
                        );
                    })}
                </ul>
            ) : (
                <div
                    style={{ height: (rowHeight - 2) + "px" }}
                    className="scroll-item"
                >
                    <SafeFlightLogo
                        logoSize={logoSize}
                        mainFlightNumber={flightNumber}
                    />
                </div>
            )}
        </div>
    );
};

export default AirlineCell;